import { jsxs as _jsxs } from "react/jsx-runtime";
import { gql } from "@apollo/client";
gql `
  fragment ChooseSubscriptionScreenVariant on Variant {
    id
    description
    additionalCost {
      amount
    }
    platformName
    platformId
  }
`;
const VariantOption = (variant) => {
    return (_jsxs("option", { value: variant.id, children: [variant.description, variant.additionalCost.amount > 0
                ? ` +$${(variant.additionalCost.amount * 0.01).toFixed(2)}`
                : null] }, variant.id));
};
export default VariantOption;
